import { use_slice_ui } from '@/hooks/store/use_slices';
import { cn } from '@/utils/utils_client';
import { useEffect, useState } from 'react';

interface PROPS {
  hash: string;
  has_effect_on_generation: boolean;
}

export function G_LABEL__hash({ hash, has_effect_on_generation }: PROPS) {
  const { g_graph__show_hashes } = use_slice_ui(['g_graph__show_hashes']);
  const [is_blinking, set_is_blinking] = useState(false);

  /*
   * EFFECTS
   */

  // Trigger the effect whenever hash changes
  useEffect(() => {
    if (!hash) return;

    set_is_blinking(true);

    // Remove the class after the animation duration (e.g., 500ms)
    const timer = setTimeout(() => set_is_blinking(false), 500);
    return () => clearTimeout(timer);
  }, [hash]);

  /*
   *
   */
  function get_opacity() {
    if (hash.is_empty_hash_sha256()) return 'opacity-10';
    if (!has_effect_on_generation) return 'opacity-10';

    return 'opacity-100';
  }

  /*
   * HTML
   */

  if (!g_graph__show_hashes) return null;

  const display_hash = hash ? hash.remove_string_protocol() : 'no hash';

  return (
    <span
      className={cn(
        `w-24 min-w-24 max-w-24 block truncate text-xs transition-colors duration-300`,
        !has_effect_on_generation && 'line-through',
        get_opacity(),
        is_blinking ? 'bg-yellow-200 dark:bg-yellow-900/30 text-yellow-900 dark:text-yellow-200' : '',
      )}
      style={is_blinking ? { animation: 'blink 0.5s ease-in-out' } : {}}
    >
      {display_hash}

      {/* Inline Styles for the animation frames */}
      <style>{`
        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
      `}</style>
    </span>
  );
}
